export default "__VITE_ASSET__CpXzrbTc__"